export default __webpack_public_path__ + "static/media/image_6.e327e192.jpg";